module.exports = __webpack_public_path__ + "img/hero-bg1.a8966c70.png";